class LangChooser {
  constructor(id) {
    this.langChooser = document.getElementById(id)

    if (this.langChooser) {
      this.langChooser.addEventListener(
          'change', () => {            
            return window.location.replace(this.langChooser.value)
          })
    }
  }
}

export default LangChooser